<ng-template #stack let-text>
  <div class="prize-stack">
    @if (hasShadow()) {
      <div [ngStyle]="shadowStyles() | theme" class="prize-shadow">{{ text }}</div>
    }
    <div [ngStyle]="textStyles() | theme" class="prize-text">{{ text }}</div>
  </div>
</ng-template>

@if (primary().icon && primary().iconPosition === "start") {
  <app-currency-icon [icon]="primary().icon!" sizeCss="--icon-medium" />
}
<ng-container *ngTemplateOutlet="stack; context: { $implicit: primary().text }" />
@if (primary().icon && primary().iconPosition === "end") {
  <app-currency-icon [icon]="primary().icon!" sizeCss="--icon-medium" />
}
@if (shownSecondary(); as secondary) {
  <div class="secondary-span">
    <ng-container *ngTemplateOutlet="stack; context: { $implicit: '(' }" />
    <div class="secondary-icon-span">
      @if (secondary.icon && secondary.iconPosition === "start") {
        <app-currency-icon [icon]="secondary.icon!" sizeCss="--icon-medium" />
      }
      <ng-container *ngTemplateOutlet="stack; context: { $implicit: secondary.text }" />
      @if (secondary.icon && secondary.iconPosition === "end") {
        <app-currency-icon [icon]="secondary.icon!" sizeCss="--icon-medium" />
      }
    </div>
    <ng-container *ngTemplateOutlet="stack; context: { $implicit: ')' }" />
  </div>
}
